import { Link } from "react-router-dom";
import { MapPin, CheckCircle2, BadgeCheck, Users, ChevronRight } from "lucide-react";

export default function CompanyCard({ item, date }) {
  const { company, available = [], busy = [], available_count = 0 } = item;
  const dateQ = date ? `?date=${date}` : "";
  return (
    <div data-testid={`company-card-${company.id}`}
      className="card overflow-hidden hover:scale-[1.01] hover:border-[#D4AF37]/40 hover:shadow-2xl transition-all duration-300">
      <div className="flex flex-col sm:flex-row">
        <div className="sm:w-56 h-44 sm:h-auto shrink-0 relative">
          <img src={company.logo || "https://images.pexels.com/photos/4717550/pexels-photo-4717550.jpeg"} alt={company.name}
            className="w-full h-full object-cover" loading="lazy" />
          {available_count > 0 && (
            <div className="absolute top-3 left-3 badge-gold backdrop-blur bg-[#070C1E]/70" data-testid={`availability-badge-${company.id}`}>
              {available_count} kaynak müsait
            </div>
          )}
        </div>
        <div className="flex-1 p-5">
          <div className="flex items-start justify-between gap-3">
            <div>
              <Link to={`/firma/${company.slug}${dateQ}`} className="text-lg font-bold text-white hover:text-[#D4AF37] transition-colors flex items-center gap-2">
                {company.name}
                {company.verified && <BadgeCheck size={18} className="text-[#D4AF37]" />}
              </Link>
              <div className="flex items-center gap-1.5 text-sm text-slate-400 mt-1">
                <MapPin size={14} /> {company.city}{company.district ? ` / ${company.district}` : ""}
              </div>
            </div>
            <Link to={`/firma/${company.slug}${dateQ}`} data-testid={`company-detail-${company.id}`} className="btn-ghost !py-2 !px-4 text-xs shrink-0">
              Detayları Gör <ChevronRight size={14} />
            </Link>
          </div>
          <div className="mt-4 space-y-2">
            {available.slice(0, 4).map((r) => (
              <Link key={r.id} to={`/firma/${company.slug}/kaynak/${r.id}${dateQ}`}
                data-testid={`resource-row-${r.id}`}
                className="flex items-center justify-between gap-3 bg-[#070C1E]/60 border border-[#10B981]/20 rounded-xl px-4 py-2.5 hover:border-[#10B981]/50 transition-colors group">
                <div className="flex items-center gap-3 min-w-0">
                  <CheckCircle2 size={16} className="text-[#10B981] shrink-0" />
                  <span className="text-sm font-semibold text-slate-100 truncate group-hover:text-[#D4AF37] transition-colors">{r.name}</span>
                  {r.max_capacity > 0 && (
                    <span className="text-xs text-slate-500 flex items-center gap-1 shrink-0"><Users size={12} /> {r.min_capacity}-{r.max_capacity} kişi</span>
                  )}
                  {r.meal_yemekli && <span className="badge-gold !py-0.5 !px-2 shrink-0">Yemekli</span>}
                  {r.meal_yemeksiz && <span className="badge-gold !py-0.5 !px-2 shrink-0">Yemeksiz</span>}
                </div>
                <span className="badge-green shrink-0">Müsait</span>
              </Link>
            ))}
            {busy.slice(0, 2).map((r) => (
              <div key={r.id} className="flex items-center justify-between gap-3 bg-[#070C1E]/40 border border-white/5 rounded-xl px-4 py-2.5 opacity-60">
                <span className="text-sm text-slate-400 truncate">{r.name}</span>
                <span className="badge-red shrink-0">Dolu</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
